module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Picker-38d59e36c0a186df326014229512c072.svg";